import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { WooCommerceService } from 'src/app/services/woocommerce.service';

@Component({
  selector: 'app-store-header',
  templateUrl: 'store-header.component.html',
  styleUrls: ['store-header.component.scss']
})
export class StoreHeaderComponent implements OnInit {
  menuOpen = false;
  userName = '';
  userPoints: number | null = null;
  /** Nombre de la unidad de puntos (ej. "puntos") desde la API. */
  pointsName = '';

  constructor(
    private router: Router,
    private loginService: LoginService,
    private woocommerceService: WooCommerceService
  ) {}

  ngOnInit() {
    const cached = this.woocommerceService.getCachedStoreUserInfo();
    if (cached) {
      if (cached.user) {
        this.userName = cached.user.name ?? '';
        this.userPoints = cached.user.points != null ? cached.user.points : null;
      }
      this.pointsName = this.woocommerceService.getPointsNameFromUserInfo(cached);
    }
    this.woocommerceService.getStoreUserInfo().subscribe({
      next: (res: any) => {
        if (res?.user) {
          this.userName = res.user.name ?? '';
          this.userPoints = res.user.points != null ? res.user.points : null;
        }
        this.pointsName = res?.points_name ?? res?.pointsName ?? res?.user?.points_name ?? '';
      },
      error: () => {
        this.setUserFromSession();
      }
    });
  }

  setUserFromSession() {
    const session = this.loginService.rescueSessionDataUser();
    if (session?.account?.name) this.userName = session.account.name;
    else if (session?.user?.name) this.userName = session.user.name;
    else if (session?.account?.username) this.userName = session.account.username;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  goToStore() {
    this.router.navigate(['store']);
  }

  goToOrders() {
    this.router.navigate(['store', 'orders']);
  }
}
